import { Directive, HostBinding, OnChanges, input } from '@angular/core';

export type ButtonType = 'primary' | 'light' | 'dark' | 'danger' | 'success';

@Directive({
  selector: 'button[buttonTheme][buttonType]',
})
export class ButtonDirective implements OnChanges {
  // Binds the generated class string to the 'class' attribute of the button
  @HostBinding('class') buttonClass: string | undefined;

  buttonTheme = input.required<ButtonType>(); // Button theme.
  buttonType = input.required<'regular' | 'square'>(); // Button type (e.g., regular or square).
  size = input<'rg' | 'sm'>('rg'); // Button size with default value 'rg'
  icon = input<string | undefined>(undefined); // Optional icon associated with the button
  loading = input<boolean>(false); // Indicating the loading state of the button.
  iconName: string | undefined; // Holds the current icon name.

  ngOnChanges(): void {
    // Generate the base CSS classes for the button
    this.buttonClass = `btn btn-${this.buttonTheme()} btn-${this.size()}`;

    // Add the 'square' class if the button type is square
    if (this.buttonType() === 'square') {
      this.buttonClass += ' square';
    }

    // Update the current icon name
    this.iconName = this.icon();
  }
}

// Extending to the anchor tags as well.
@Directive({
  selector: 'a[buttonTheme][buttonType]',
})
export class CustomButtonLinkDirective extends ButtonDirective {}
